const MobileDetect = require("mobile-detect");

export const md = new MobileDetect(navigator.userAgent);
